import $ from 'jquery';
import 'common/js/csrf';

var jsonAjax = function(opts) {
    var defaults = {contentType: 'application/json', dataType: 'json'},
        params = $.extend(defaults, opts);

    if (params.data && typeof params.data !== 'string')
        params.data = JSON.stringify(params.data);

    return $.ajax(params);
};

jsonAjax.post = function (url, data) {
    return jsonAjax({type: 'POST', url: url, data: data});
};

jsonAjax.put = function (url, data) {
    return jsonAjax({type: 'PUT', url: url, data: data});
};

jsonAjax.delete_ = function (url) {
    return $.ajax({type: 'DELETE', url: url});
};

export default jsonAjax;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/helpers/jsonAjax.js
 **/